import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { hotkeys } from 'react-keyboard-shortcuts';
import AddButton from '../../core/AddButton';
import CancelButton from '../../core/CancelButton';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import SearchDropDown from '../../core/SearchDropDown';
import { globalStyles } from '../../core/style/gstheme';
import SchemeLink from '../core/SchemeLink';
import XL from '../core/XL';

const styles = Object.assign({}, globalStyles);

class FindConceptDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    hot_keys = {
        'alt+ctrl+f': {
            priority: 1,
            handler: () => this.handleClickOpen(),
        }
    };

    handleClickOpen = () => this.setState({ open: true });

    includeConcept = (id) => {
        this.props.onIncludeConcept(id);
        this.exitFindConcept();
    };

    exitFindConcept = () => this.setState({ open: false });

    render() {

        const { classes, button, exclude, graph } = this.props;
        const findButton = button || <AddButton title="Find a concept" />;

        return (
            <ProjectConsumer>
                {({ skosXL, defaultLang }) => (
                    <React.Fragment>
                        <span data-test="add-concept" onClick={this.handleClickOpen}>{findButton}</span>
                        <Dialog
                            data-test="find-concept-for-collection"
                            maxWidth="md"
                            fullWidth
                            classes={{
                                paper: classes.paper,
                                paperWidthMd: classes.mediumDialog
                            }}
                            className={classes.dialog}
                            open={this.state.open}
                            onClose={this.exitAddConcept}
                            aria-labelledby="concept-dialog-title">
                            <DialogTitle disableTypography className={classes.mainHeading} id="concept-dialog-title">Find a Concept</DialogTitle>
                            <DialogContent style={{ height: '120px', overflow: 'visible' }}>
                                <DialogContentText className={classes.dialogText}>Start typing the label of a concept in this project.</DialogContentText>
                                <SearchDropDown
                                    dataTest="find-concept"
                                    focus={true}
                                    wrapped={true}
                                    search={(value, lang) => {
                                        return {
                                            "search": [{
                                                "predicate": [
                                                    "http://www.w3.org/2004/02/skos/core#prefLabel"
                                                ],
                                                "value": value,
                                                "isExactMatch": false
                                            },
                                            {
                                                "predicate": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                                                "value": "http://www.w3.org/2004/02/skos/core#Concept"
                                            }],
                                            "graph": [graph],
                                            "exclude": exclude,
                                            "language": lang,
                                            "entailment": skosXL ? ["propertyChain"] : [],
                                            "predicates": [
                                                "http://www.w3.org/2004/02/skos/core#prefLabel",
                                                "https://grafsync.graphifi.com/schema/gs/iri",
                                                "http://www.w3.org/2004/02/skos/core#inScheme"
                                            ]
                                        };

                                    }}
                                    listSecondIcon={(result, lang) => {
                                        if (result.isEntailed) return <XL />;
                                        return null;
                                    }}
                                    listSelectionDisplay={(result, lang) => {
                                        if (result.prefLabel && result.prefLabel[lang]) {
                                            return Array.isArray(result.prefLabel[lang]) ?
                                                result.prefLabel[lang][0]
                                                :
                                                result.prefLabel[lang];
                                        }
                                        else return "No label available";
                                    }}
                                    listDisplay={(result, lang) => {
                                        const text = result.prefLabel && result.prefLabel[lang] ?
                                            Array.isArray(result.prefLabel[lang]) ?
                                                result.prefLabel[lang].sort().join(" AND ")
                                                :
                                                result.prefLabel[lang]
                                            :
                                            "No label available";
                                        const currentIRI = result.iri ?
                                            result.iri[result.iri.length - 1]
                                            :
                                            result.id;
                                        return <div>
                                            <Typography variant="body2">
                                                <Tooltip
                                                    PopperProps={{
                                                        "data-test": "result-tip"
                                                    }}
                                                    title={currentIRI}>
                                                    <span data-test="result-text-words">{text}</span>
                                                </Tooltip>
                                            </Typography>
                                            {result.inScheme && result.inScheme.map(scheme =>
                                                <SchemeLink handleNotAvailable={true} key={scheme} id={scheme} graph={graph} defaultLang={defaultLang} />
                                            )}
                                        </div>;
                                    }}
                                    sortProp="prefLabel"
                                    title="Find a concept"
                                    lang={defaultLang}
                                    chosen={this.includeConcept} />
                            </DialogContent>
                            <DialogActions className={classes.dialogActions}>
                                <CancelButton onClick={this.exitFindConcept} />
                            </DialogActions>
                        </Dialog>
                    </React.Fragment>
                )}
            </ProjectConsumer>
        );
    }
}

FindConceptDialog.propTypes = {
    classes: PropTypes.object,
    button: PropTypes.object,
    graph: PropTypes.string.isRequired,
    exclude: PropTypes.array
};

export default withStyles(styles)(hotkeys(FindConceptDialog));